"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Carousel3dComponent = void 0;

var React = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _animation = require("./animation");

var _carousel3dItem = _interopRequireDefault(require("./carousel-3d-item"));

var _svg = _interopRequireDefault(require("../svg"));

var _keyboardCommands = require("../keyboard-commands");

var _layoutConstants = _interopRequireDefault(require("../../util/layout-constants"));

require("./carousel-3d.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @typedef {object} Carousel3dItemData
 * @property {string} id Unique id for image
 * @property {string} url Image url
 * @property {string} title Title of the image, displayed below the image
 */

/**
 * @callback Carousel3dOnChange
 * @param {string} image The id of the image that moved to the front of the
 * carousel
 * @returns {void}
 */

/**
 * @typedef {object} Carousel3dProps
 * @property {Carousel3dItemData[]} data A list of items used to populate
 * items in the carousel
 * @property {string} selectedImage Id of the currently selected image, animates
 * carousel to image
 * @property {Carousel3dOnChange} onChange Called when a new image moves to the
 *                                         front of the carousel
 * @property {number} imageWidth Width of each image in the carousel
 * @property {number} imageHeight Height of each image in the carousel
 */

/**
 * @typedef {object} Carousel3dState
 * @property {number} rotation How far the carousel has rotated around the y
 * axis
 * @property {number} containerWidth Width of the container that wraps all of
 * the other elements
 */

/**
 * @class
 * @extends {React.Component<Carousel3dProps, Carousel3dState>}
 */
var Carousel3dComponent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Carousel3dComponent, _React$Component);

  /** How long to wait before animating to the image closest to the front of the
   * carousel and calling the onChange handler */

  /** This ratio controls how many degrees to rotate the carousel based on the
  distance in pixels that a user has dragged across the screen */

  /** Acceleration is measured in degrees/millisecond². This value is used to
   * gradually slow the carousel to a stop after releasing a drag interaction */

  /** Maximum velocity when releasing the drag, prevents the carousel from
   * spinning too far */

  /** How long to wait before updating the layout based on the dimensions of the
   * component */

  /** Max width of the component to take into consideration when scaling the
   * images up and down */

  /** Min width of the component to take into consideration when scaling the
   * images up and down */

  /** This is necessary for server-side rendering, where there is no global
   * window object */
  function Carousel3dComponent(props) {
    var _this;

    _classCallCheck(this, Carousel3dComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Carousel3dComponent).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "changeToFrontImage", function () {
      var _this$props = _this.props,
          data = _this$props.data,
          onChange = _this$props.onChange;
      var rotation = _this.state.rotation;
      var index = Math.round(rotation / 360 * data.length) % data.length;
      var item = data[index];

      if (item) {
        onChange(item.id);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onContainerWheel", function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.preventDefault();

        _this.rotate(e.deltaX * Carousel3dComponent.degreesPerPixel, _this.changeToFrontImage);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onContainerMouseDown", function (e) {
      e.preventDefault();

      if (Carousel3dComponent.windowExists()) {
        window.document.addEventListener('mouseup', _this.onMouseUp);
        window.document.addEventListener('mousemove', _this.onMouseMove);
      }

      _this.cancelAnimations();

      _this.lastDragX = e.clientX;
    });

    _defineProperty(_assertThisInitialized(_this), "onContainerTouchStart", function (e) {
      if (e.touches && e.touches[0]) {
        _this.cancelAnimations();

        _this.lastDragX = e.touches[0].clientX;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onContainerTouchMove", function (e) {
      if (e.touches && e.touches[0]) {
        _this.drag(e.touches[0].clientX);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onContainerTouchEnd", function () {
      if (Math.abs(_this.velocity) > 0) {
        _this.slowToStop();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseMove", function (e) {
      _this.drag(e.clientX);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseUp", function () {
      if (Math.abs(_this.velocity) > 0) {
        _this.slowToStop();
      }

      if (Carousel3dComponent.windowExists()) {
        window.document.removeEventListener('mouseup', _this.onMouseUp);
        window.document.removeEventListener('mousemove', _this.onMouseMove);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onImageClick", function (image) {
      if (_this.velocity === 0) {
        var onChange = _this.props.onChange;
        onChange(image.id);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "resize", function () {
      if (!_this.containerRef.current) {
        return;
      }

      _this.setState({
        containerWidth: _this.containerRef.current.offsetWidth
      });
    });

    _defineProperty(_assertThisInitialized(_this), "slowToStop", function () {
      var lastDisplacement = 0; // If the carousel is rotating in a positive direction, acceleration needs
      // to be negative in order to slow it down and visa versa

      var acceleration = -Math.sign(_this.velocity) * Carousel3dComponent.acceleration;

      var onStep = function onStep(_ref) {
        var displacement = _ref.displacement,
            velocity = _ref.velocity;
        var displacementDelta = displacement - lastDisplacement;
        _this.velocity = velocity;
        lastDisplacement = displacement;

        _this.rotate(displacementDelta, _this.changeToFrontImage);
      };

      _this.cancelSlowToStop = (0, _animation.accelerate)(_this.velocity, 0, acceleration, onStep);
    });

    _defineProperty(_assertThisInitialized(_this), "nextImage", function () {
      var _this$props2 = _this.props,
          data = _this$props2.data,
          selectedImage = _this$props2.selectedImage,
          onChange = _this$props2.onChange;
      var index = data.findIndex(function (i) {
        return i.id === selectedImage;
      });
      var nextImageIndex = (index + 1) % data.length;
      onChange(data[nextImageIndex].id);
    });

    _defineProperty(_assertThisInitialized(_this), "previousImage", function () {
      var _this$props3 = _this.props,
          data = _this$props3.data,
          selectedImage = _this$props3.selectedImage,
          onChange = _this$props3.onChange;
      var index = data.findIndex(function (i) {
        return i.id === selectedImage;
      });
      var previousIndex = index === 0 ? data.length - 1 : index - 1;
      onChange(data[previousIndex].id);
    });

    _this.containerRef = React.createRef();
    _this.lastDragTime = 0;
    _this.lastDragX = 0;
    /** Velocity is measured in deg/ms */

    _this.velocity = 0;

    _this.cancelAnimateToImage = function () {};

    _this.cancelSlowToStop = function () {};

    _this.debouncedResize = _lodash["default"].debounce(_this.resize, Carousel3dComponent.resizeDebounceWait);
    _this.changeToFrontImage = _lodash["default"].debounce(_this.changeToFrontImage, Carousel3dComponent.changeToFrontImageDebounceWait);
    _this.state = {
      containerWidth: 0,
      rotation: 0
    };
    return _this;
  }

  _createClass(Carousel3dComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.resize(); // Fix issue that can occur when JavaScript is executed before styles are
      // applied to the page

      setTimeout(function () {
        return _this2.resize();
      });

      if (Carousel3dComponent.windowExists()) {
        // Fix issue that can occur when JavaScript is executed before styles are
        // applied to the page
        window.addEventListener('load', this.resize);
        window.addEventListener('resize', this.debouncedResize);
      }

      this.containerRef.current.addEventListener('wheel', this.onContainerWheel);
    }
    /**
     * Animate to the selected image when it changes
     * @param {Carousel3dProps} prevProps
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var selectedImage = this.props.selectedImage;

      if (selectedImage && selectedImage !== prevProps.selectedImage) {
        this.cancelAnimations();
        this.animateToImage(selectedImage);
      }
    }
    /** Clean up event listeners and clear any animations that are in progress */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (Carousel3dComponent.windowExists()) {
        window.removeEventListener('load', this.resize);
        this.debouncedResize.cancel();
        window.removeEventListener('resize', this.debouncedResize);
      }

      this.cancelAnimations();
    }
    /** Scale images proportionally to the width of the carousel */

  }, {
    key: "getImageDimensions",
    value: function getImageDimensions() {
      var _this$props4 = this.props,
          imageWidth = _this$props4.imageWidth,
          imageHeight = _this$props4.imageHeight;
      var containerWidth = this.state.containerWidth;
      var scale = _lodash["default"].clamp(containerWidth, Carousel3dComponent.minImageScaleWidth, Carousel3dComponent.maxImageScaleWidth) / Carousel3dComponent.maxImageScaleWidth;
      return [imageWidth * scale, imageHeight * scale];
    }
    /** When scrolling stops call the onChange handler with the closest image */

  }, {
    key: "cancelAnimations",

    /**
     * Cancel all animations
     */
    value: function cancelAnimations() {
      this.cancelAnimateToImage();
      this.cancelSlowToStop();
    }
    /**
     * Update variables needed for slow to stop animation and rotate the carousel
     * by the distance the user has dragged
     * @param {number} clientX The current
     */

  }, {
    key: "drag",
    value: function drag(clientX) {
      var time = performance.now() - this.lastDragTime;
      this.lastDragTime = performance.now();
      var distance = (clientX - this.lastDragX) * Carousel3dComponent.degreesPerPixel * -1;
      this.lastDragX = clientX;
      this.velocity = _lodash["default"].clamp(distance, -Carousel3dComponent.maxDragVelocity, Carousel3dComponent.maxDragVelocity) / time;
      this.rotate(distance);
    }
    /**
     * Rotate the carousel by the distance provided
     * @param {number} distance
     * @param {function} [callback]
     */

  }, {
    key: "rotate",
    value: function rotate(distance, callback) {
      var rotation = this.state.rotation;
      var newRotation = (rotation + distance) % 360;

      if (newRotation < 0) {
        newRotation = 360 + newRotation;
      }

      this.setState({
        rotation: newRotation
      }, function () {
        if (_lodash["default"].isFunction(callback)) {
          callback();
        }
      });
    }
    /**
     * Calculate which direction to rotate and how far, then animate to that image
     * @param {string} imageId
     */

  }, {
    key: "animateToImage",
    value: function animateToImage(imageId) {
      var _this3 = this;

      var data = this.props.data;
      var rotation = this.state.rotation;
      var index = data.findIndex(function (i) {
        return i.id === imageId;
      });
      var newRotation = index / data.length * 360;
      var distance = 0;

      if (newRotation > rotation) {
        var distanceRight = (360 - newRotation + rotation) * -1;
        var distanceLeft = newRotation - rotation;
        distance = Math.abs(distanceRight) > distanceLeft ? distanceLeft : distanceRight;
      } else {
        var _distanceRight = 360 - rotation + newRotation;

        var _distanceLeft = (rotation - newRotation) * -1;

        distance = Math.abs(_distanceLeft) > _distanceRight ? _distanceRight : _distanceLeft;
      }

      var lastValue = rotation;
      this.cancelAnimateToImage = (0, _animation.animate)(rotation, rotation + distance, 300, function (r) {
        _this3.rotate(r - lastValue);

        lastValue = r;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var data = this.props.data;
      var _this$state = this.state,
          containerWidth = _this$state.containerWidth,
          rotation = _this$state.rotation;
      var mobileView = containerWidth < _layoutConstants["default"].small;
      var classes = (0, _classnames["default"])('Carousel3d', {
        'mobile-view': mobileView
      });

      var _this$getImageDimensi = this.getImageDimensions(),
          _this$getImageDimensi2 = _slicedToArray(_this$getImageDimensi, 2),
          imageWidth = _this$getImageDimensi2[0],
          imageHeight = _this$getImageDimensi2[1];
      /* eslint-disable jsx-a11y/click-events-have-key-events,
       jsx-a11y/no-static-element-interactions */


      return React.createElement("div", {
        className: classes,
        ref: this.containerRef,
        onMouseDown: this.onContainerMouseDown,
        onTouchStart: this.onContainerTouchStart,
        onTouchMove: this.onContainerTouchMove,
        onTouchEnd: this.onContainerTouchEnd,
        style: {
          height: imageHeight + 20
        }
      }, React.createElement("div", {
        className: "items"
      }, data.map(function (image, i) {
        return React.createElement(_carousel3dItem["default"], {
          key: image.id,
          image: image,
          totalImages: data.length,
          index: i,
          rotation: rotation,
          imageWidth: imageWidth,
          imageHeight: imageHeight,
          containerWidth: containerWidth,
          onClick: _this4.onImageClick
        });
      })), React.createElement("button", {
        type: "button",
        className: "arrow-left-button",
        name: "Previous Image",
        onClick: this.previousImage
      }, React.createElement(_svg["default"], {
        className: "arrow-left",
        id: "chevron-medium"
      })), React.createElement("button", {
        type: "button",
        className: "arrow-right-button",
        name: "Next Image",
        onClick: this.nextImage
      }, React.createElement(_svg["default"], {
        className: "arrow-right",
        id: "chevron-medium"
      })));
    }
  }]);

  return Carousel3dComponent;
}(React.Component);

exports.Carousel3dComponent = Carousel3dComponent;

_defineProperty(Carousel3dComponent, "imageShape", _propTypes["default"].shape({
  id: _propTypes["default"].string,
  url: _propTypes["default"].string,
  title: _propTypes["default"].string
}));

_defineProperty(Carousel3dComponent, "propTypes", {
  data: _propTypes["default"].arrayOf(Carousel3dComponent.imageShape),
  selectedImage: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired,
  imageWidth: _propTypes["default"].number,
  imageHeight: _propTypes["default"].number
});

_defineProperty(Carousel3dComponent, "defaultProps", {
  data: [],
  imageWidth: 160,
  imageHeight: 160,
  selectedImage: null
});

_defineProperty(Carousel3dComponent, "changeToFrontImageDebounceWait", 100);

_defineProperty(Carousel3dComponent, "degreesPerPixel", 0.2);

_defineProperty(Carousel3dComponent, "acceleration", 0.0005);

_defineProperty(Carousel3dComponent, "maxDragVelocity", 6);

_defineProperty(Carousel3dComponent, "resizeDebounceWait", 300);

_defineProperty(Carousel3dComponent, "maxImageScaleWidth", 1200);

_defineProperty(Carousel3dComponent, "minImageScaleWidth", 600);

_defineProperty(Carousel3dComponent, "windowExists", function () {
  return typeof window !== 'undefined';
});

var _default = Carousel3dComponent.windowExists() ? (0, _keyboardCommands.keyboardCommands)( // @ts-ignore
Carousel3dComponent, [{
  keys: 'right',
  connectCommand: function connectCommand(props, event, component) {
    component.nextImage();
  }
}, {
  keys: 'left',
  connectCommand: function connectCommand(props, event, component) {
    component.previousImage();
  }
}]) : Carousel3dComponent;

exports["default"] = _default;